export class OperationIdFilters {
    'contains';
    'notContains';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "contains",
            "baseName": "contains",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "notContains",
            "baseName": "notContains",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return OperationIdFilters.attributeTypeMap;
    }
    constructor() {
    }
}
